import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { Observable } from 'rxjs';
import { VisitsTableComponent } from 'src/app/components/tables/visit/visit-table.component';
import { Visit } from 'src/app/models/visit.model';
import { SideBarMenuService } from 'src/app/services/sidebar-menu.service';
import { VisitService } from 'src/app/services/visit.service';

@Component({
  selector: 'visits',
  standalone: true,
  imports: [BreadcrumbModule, AsyncPipe, VisitsTableComponent],
  templateUrl: './visits.component.html',
})
export class VisitsComponent {
  private visitService = inject(VisitService);
  private sidebarMenuService = inject(SideBarMenuService);
  visits$: Observable<Visit[]>;

  home: MenuItem;
  breadcrumbItems: MenuItem[] = [];

  ngOnInit(): void {
    this.home = {
      icon: 'pi pi-fw pi-mobile',
      routerLink: '/',
      command: () => this.sidebarMenuService.clearSessionStorage(),
    };
    this.breadcrumbItems = [{ label: 'Visitas', styleClass: 'font-bold' }];
    this.visits$ = this.visitService.findVisits();
  }
}
